






















import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UUIFComponent from '@/shared/uuifComponent';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
const cssPrefix = 'updateWcmDialog';
@Component({
  components:{
    ...UUIFComponent,
  },
})
export default class UpdateWcmDialog extends SwExtendedVue{
  @Prop()
  showUpdateCountry: boolean;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  countryArray: any[] = [];
  selectedCountryCode: any = '';
  selectedCode: string = '';
  @Watch('selectedCountryCode')
  private updateCountryCode() {
    this.selectedCode = this.selectedCountryCode;
  }
  cssPrefix = cssPrefix;
  get countryOptions() {
    return this.countryArray;
  }
  created() {
    this.getCountryList();
  }
  getCountryList() {
    this.$store.dispatch('MswProductsStoreModule/getCountryList', this.productDetails.serialNumber)
    .then((res) => {
      if (res.operationStatus === 'OK') {
        this.$store.commit('stopLoading');
        this.countryArray = res.content.countryList;
        this.countryArray.map((country: any) => {
          country.value = country.countryCode;
          country.label = country.name;
          country.id = country.countryCode;
          delete country.countryCode;
          delete country.name;
        });
        if (this.countryArray) {
          this.selectedCountryCode = this.countryArray.filter((country) => {
            return  country.label === this.productDetails.countryName;
          })[0].id;
        }
      }
    });
  }
  closeDialog(value:boolean = false) {
    this.$emit('closeWcmDialog', value);
  }
  onSubmit() {
    const req = {
      serialnumber: this.productDetails.serialNumber,
      countryCode: this.selectedCode,
    };
    this.$store.dispatch('MswProductsStoreModule/updateWCM', req)
    .then((res) => {
      this.$store.commit('stopLoading');
      if (res.operationStatus === 'OK') {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
        this.closeDialog(true);
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
        this.closeDialog();
      }
    });
  }
}
